

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'auth_';

export default {
  path: routePre + '/auth',
  name: 'auth',
  header: 'auth',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	
	
	{
	  path: 'admin',
	  name: `${pre}admin`,
	  meta: {
	    auth: ['auth-admin'],
	    title: '管理员',
	  },
	  component: () => import('@/pages/auth/admin'),
	},
	{
	  path: 'wechat',
	  name: `${pre}wechat`,
	  meta: {
	    auth: ['auth-wechat'],
	    title: '接量账户',
	  },
	  component: () => import('@/pages/auth/wechat'),
	},
	{
	  path: 'team',
	  name: `${pre}team`,
	  meta: {
	    auth: ['auth-team'],
	    title: '战队管理',
	  },
	  component: () => import('@/pages/auth/team'),
	},
	{
	  path: 'team/integral',
	  name: `${pre}teamIntegral`,
	  meta: {
	    title: '积分明细',
		activeMenu: routePre + '/auth/team',
	  },
	  component: () => import('@/pages/auth/team/integral'),
	},
	{
	  path: 'team/recharge',
	  name: `${pre}teamRecharge`,
	  meta: {
	    auth: ['auth-team'],
	    title: '战队续费',
		activeMenu: routePre + '/auth/team',
	  },
	  component: () => import('@/pages/auth/team/recharge'),
	},
	{
	  path: 'role',
	  name: `${pre}role`,
	  meta: {
	    auth: ['auth-role'],
	    title: '职位管理',
	  },
	  component: () => import('@/pages/auth/role'),
	},
	{
	  path: 'log',
	  name: `${pre}log`,
	  meta: {
	    auth: ['auth-log'],
	    title: '系统日志',
	  },
	  component: () => import('@/pages/auth/log'),
	},
	// {
	//   path: 'channelcode',
	//   name: `${pre}channelcode`,
	//   meta: {
	//     auth: ['auth-channelcode'],
	//     title: '渠道码',
	//   },
	//   component: () => import('@/pages/auth/channelcode'),
	// }
	
	
  ],
};
